import React from 'react';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var ModalLayout = function ModalLayout(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('container'),
    "data-t-id": "common-ModalLayout"
  }, children);
};